import {ref} from "vue";
import getData from "@/api/getData/getData";
import {infoWidgetsItems} from "./infoWidgetsItems";
import {widgets} from "@/api/url/widgetsUrls";

export function useWidget() {
    const items = ref(infoWidgetsItems)
    const isLoading = ref(true)

    getData(widgets).then((response) => {
        if (response.request.readyState === 4) {
            items.value = items.value.map((item, index) => ({...item, ...response.data[index]}));
            isLoading.value = false
        }
    })

    return {
        isLoading,
        items
    }
}